import ImageOne from '../images/pic11.jpg';
import ImageTwo from '../images/pic22.jpg';
import ImageThree from '../images/pic33.jpg';
import ImageFour from '../images/pic44.jpg';
import ImageFife from '../images/pic66.jpg';
export const SliderData = [
    {
        title: 'Luxury Villa',
        price: 'שח2,300,000',
        path: '/homes',
        label: 'עמוד הבית',
        image: ImageOne,
        alt: 'House'
    },
    {
        title: 'Luxury Villa asaf shapira',
        price: 'שח3,300,000',
        path: '/homes',
        label: 'עמוד הבית',
        image: ImageTwo,
        alt: 'House'
    },
    {
        title: 'Luxury Villa romema',
        price: 'שח1,100,000',
        path: '/homes',
        label: 'עמוד הבית',
        image: ImageThree,
        alt: 'House'
    },
    {
        title: 'Luxury Villa',
        price: '$1,300,000',
        path: '/homes',
        label: 'View Home',
        image: ImageFour,
        alt: 'House'
    },
    {
    title: 'Luxury Villa',
    price: '$1,300,000',
    path: '/homes',
    label: 'View Home',
    image: ImageFife,
    alt: 'House'
    },
];